var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sequences.length > 0)?_c('div',{attrs:{"id":"trackList"}},[_c('h3',[_vm._v("Tracks")]),_vm._v(" "),_c('ul',{staticClass:"list-group"},_vm._l((_vm.sortedSequences),function(sequence){return _c('DataListItem',{key:sequence.id,attrs:{"sequence":sequence,"current":_vm.current},on:{"deleteSequence":function($event){_vm.sequences.splice(_vm.sequences.findIndex(function (x) { return x == sequence; }), 1)}}})}))]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ec16438","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DataList.vue
// module id = 26
// module chunks = 0